export const NOTIFICATION_EVENTS = '/admin/app/notification-events';
export const NOTIFICATION_TEMPLATES = '/admin/app/notification-templates';
export const NOTIFICATION_EVENT_SETTINGS = 'admin/notification-events/settings/';
//Dashboard
export const DEFAULT_INFO = 'default-info';
export const DEFAULT_ACADEMIC_INFO = 'default-academic-info';
export const DEFAULT_DASHBOARD_INFO = 'default-dashboard-info';
export const AVAILABLE_COURSE_LIST = 'available-course-list';
export const STUDENT_OVERVIEW = 'student-overview';
export const SCHOOL_OVERVIEW = 'school-overview';
export const INSTRUCTOR_STUDENT_OVERVIEW = 'instructor-student-overview';
export const AUDIENCE_OVERVIEW_CHART = 'audience-overview-chart';
export const BROWSER_OVERVIEW_CHART = 'browser-overview-chart';
export const BUSINESS_OVERVIEW = 'business-overview';
export const CONTACT_OVERVIEW = 'contact-overview';
export const TEAM_OVERVIEW = 'team-overview';
export const DOCTORS_LIST = 'doctors-list';
export const UPCOMING_APPOINTMENTS = 'upcoming-appointments';
export const DEFAULT_HOSPITAL_INFO = 'default-hospital-info';
export const HOSPITAL_ACTIVITIES = 'hospital-activities';
export const PATIENT_STATISTICS = 'patient-statistics';
export const HRM_BASIC_DATA = 'hrm-basic-data';
export const PROJECT_OVERVIEW = 'project-overview';
export const YEARLY_HOLIDAY = 'yearly-holiday';
export const EMPLOYEE_OVERVIEW = 'employee-overview';

//Sample pages
export const REPORTS = 'reports';
export const CALENDARS = 'calendars';
export const STAGES = 'stages';
export const TASKS = 'tasks';

//Profile
export const MY_PROFILE = '/my-profile';
export const All_NOTIFICATION = '/all-notifications';
export const LOGOUT = '/admin/log-out';

//app setting view
export const APP_SETTINGS = '/app-setting';
export const GENERAL_SETTINGS = 'general-settings';

//storage setting
export const STORAGE_SETTING = '/storage-configuration';

//reCAPTCHA
export const GET_RECAPTCHA_SETTINGS = '/get-re-captcha-setting';
//Sms settings
export const GET_SMS_SETTINGS_INFO = 'get-sms-setting-info';
//Email settings
export const GET_EMAIL_SETTINGS = '/admin/app/settings/delivery-settings';
//Plan Margins
export const GET_PLAN_MARGINS = '/admin/app/settings/plan-margins';
export const UPDATE_PLAN_MARGINS = '/admin/app/settings/plan-margins';

//Beneficiary Plan Margins
export const GET_BENEFICIARY_PLAN_MARGINS = '/beneficiario/plan-margins';
export const UPDATE_BENEFICIARY_PLAN_MARGINS = '/beneficiario/plan-margins';

//DataTable
export const DATATABLE_DATA = 'crud';
export const DATATABLE_EXPORT = 'export-crud';
export const DATATABLE_SEARCH_SELECT = '/datatable/name';
export const DATATABLE_SERVER_SEARCH_SELECT = '/datatable/serverside/selectable-name';

//Custom TAble
export const CUSTOM_TABLE = 'admin/app/custom-tables';

//Beneficiarios
export const BENEFICIARIOS = 'beneficiarios';
export const BENEFICIARIOS_EXPORT_COMMISSIONS = (id) => `beneficiarios/${id}/export-commissions`;
export const BENEFICIARIOS_VISUAL_COMMISSIONS = (id) => `beneficiarios/${id}/visual-commissions`;

//Super Partners
export const SUPER_PARTNERS = 'super-partners';
export const SUPER_PARTNER_COMMISSIONS = (id) => `super-partners/${id}/commissions`;

//Clientes
export const CLIENTES = 'clientes';
export const CLIENTES_IMPORT = 'clientes/import';

//Transactions
export const TRANSACTIONS = 'transactions';
export const TRANSACTIONS_PAYMENT_STATS = 'transactions/payment-stats';
export const TRANSACTIONS_CALCULATE_AMOUNT = 'transactions/calculate-payment-amount';
export const TRANSACTIONS_MARK_AS_PAID = 'transactions/mark-as-paid';
export const TRANSACTIONS_NOMAD_DEBT_STATS = 'transactions/nomad-debt-stats';
export const TRANSACTIONS_NOMAD_COURTESY_COUNTRIES = 'transactions/nomad-courtesy-countries';
export const TRANSACTIONS_NOMAD_COURTESY_ESIM = 'transactions/nomad-courtesy-esim';
export const TRANSACTIONS_ESIM_STATUS = (id) => `transactions/${id}/esim-status`;
export const TRANSACTIONS_TERMINATE = (id) => `transactions/${id}/terminate-subscription`;
export const TRANSACTIONS_RECHARGE = (id) => `transactions/${id}/recharge`;
export const TRANSACTIONS_SEND_RECHARGE_EMAIL = (id) => `transactions/${id}/send-recharge-email`;
export const TRANSACTIONS_SALE_COMMISSION_TOTAL = 'transactions/sale-commission-total';

//Payment Histories
export const PAYMENT_HISTORIES = 'payment-histories';
export const PAYMENT_HISTORIES_CANCEL = (id) => `payment-histories/${id}/cancel`;

//roles and users
export const ROLES = 'admin/auth/roles';
export const USERS = 'admin/auth/users';
export const USERS_LIST = '/user-list';
export const CREATE_USER = '/user-list';
export const ALL_USERS = 'all-users';
export const GET_USERS = 'get/users';
export const GET_STATUSES = 'admin/app/statuses';
export const INVITE_USER = '/admin/auth/users/invite-user';
export const DETACH_ROLES = 'admin/auth/users/detach-roles/';
export const UPDATE_USER_NAME = '/update-user-name/';

//Notification
export const NOTIFICATIONS = '/admin/user/notifications';
export const AUTHENTICATE_USER = '/admin/authenticate-user';
export const LOGIN_USER = '/login-user';

// Language
export const LANGUAGE = 'languages';
export const BASIC_SETTINGS = '/get-basic-setting-data';

// Social links
export const CHANGE_SOCIAL_LINKS = '/change-social-link';

//Payment Methods
export const PAYMENT_METHOD = '/payment-method';
export const GET_PAYMENT_METHOD_STATUS = '/payment-method-status';
export const GET_STRIPE_STATUS = '/stripe-status';
export const GET_PAYPAL_STATUS = '/paypal-status';
export const GET_RAZORPAY_STATUS = '/razorpay-status';
export const GET_RAZORPAY_INFORMATION = '/razor-pay-information';
